function toPositiveNumber(value, fallback = 0) {
  const n = Number(value);
  return Number.isFinite(n) && n >= 0 ? n : fallback;
}

function normalizeLotQuantity(lot) {
  return Math.max(0, toPositiveNumber(lot?.quantity, 0));
}

function normalizeLotWeightKg(lot) {
  const avgWeight = toPositiveNumber(lot?.avgWeight, 0);
  if (avgWeight > 0) return avgWeight;
  if (Array.isArray(lot?.animals) && lot.animals.length) {
    const weights = lot.animals.map((animal) => toPositiveNumber(animal?.weight, 0)).filter((weight) => weight > 0);
    if (weights.length) return weights.reduce((sum, weight) => sum + weight, 0) / weights.length;
  }
  return 450;
}

function estimatePastureOccupancy(animalLots = [], pastureId, climateRiskThreshold = 0.9, capacityUaTotal = 0) {
  const id = String(pastureId || "").trim();
  if (!id) {
    return {
      usedUa: 0,
      availableUa: Math.max(0, Number(capacityUaTotal || 0)),
      ratio: 0,
      headCount: 0,
      lotsCount: 0,
      status: "Sem lotação",
      tone: "muted",
      linkedLots: [],
    };
  }

  const linkedLots = (Array.isArray(animalLots) ? animalLots : []).filter((lot) => {
    if (!lot || typeof lot !== "object") return false;
    if (lot._deleted || lot.deletedAt || lot.deleted_at) return false;
    return String(lot.pastureId || "") === id;
  });

  const summary = linkedLots.reduce((acc, lot) => {
    const qty = normalizeLotQuantity(lot);
    const avgWeightKg = normalizeLotWeightKg(lot);
    const usedUa = qty > 0 ? (qty * avgWeightKg) / 450 : 0;
    acc.usedUa += usedUa;
    acc.headCount += qty;
    acc.lotsCount += 1;
    return acc;
  }, { usedUa: 0, headCount: 0, lotsCount: 0 });

  const totalCapacity = Math.max(0, toPositiveNumber(capacityUaTotal, 0));
  const availableUa = Math.max(0, totalCapacity - summary.usedUa);
  const ratio = totalCapacity > 0 ? summary.usedUa / totalCapacity : 0;
  const threshold = Math.max(0.5, toPositiveNumber(climateRiskThreshold, 0.9));

  let status = "Sem lotação";
  let tone = "muted";
  if (summary.lotsCount > 0 || summary.headCount > 0 || summary.usedUa > 0) {
    if (totalCapacity <= 0) {
      status = "Sem capacidade definida";
      tone = "red";
    } else if (ratio >= 1) {
      status = "Superlotação";
      tone = "red";
    } else if (ratio >= threshold) {
      status = "Provável superlotação";
      tone = "yellow";
    } else {
      status = "Lotação dentro da capacidade";
      tone = "green";
    }
  }

  return {
    usedUa: Number(summary.usedUa.toFixed(2)),
    availableUa: Number(availableUa.toFixed(2)),
    ratio: Number(ratio.toFixed(2)),
    headCount: summary.headCount,
    lotsCount: summary.lotsCount,
    status,
    tone,
    linkedLots,
  };
}

export { estimatePastureOccupancy };
